import { cn } from '@/utils/cn';
import { DashedLine } from '@packages/webshop-design-system';

interface TicketCuticleLineProps {
  isVertical?: boolean;
  className?: string;
  dashLength?: number;
  dashColor?: string;
}

const TicketCuticleLine = ({
  isVertical = false,
  className,
  dashLength = 12,
  dashColor = '#C2C8D6',
}: TicketCuticleLineProps) => {
  return (
    <DashedLine
      isVertical={isVertical}
      dashLength={dashLength}
      gapLength={4}
      color={dashColor}
      className={cn('flex-1', className)}
    />
  );
};

export default TicketCuticleLine;
